import React from 'react';
import { Alert, Box, FormControlLabel, MenuItem, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import QrisKasir from './QrisKasir';
import { hitungReservasiBayar } from '../../utils/reservasiBayar';
import { namaMejaReservasi } from '../../utils/reservasi';

const rp = (n) => `Rp ${Math.round(Number(n) || 0).toLocaleString('id-ID')}`;

/**
 * Panel pembayaran dengan DP reservasi (kasir cafe): pilih reservasi yang DP-nya sudah diterima, DP dipotong dari tagihan,
 * sisanya dibayar tunai, non-tunai, atau QRIS (QR ditampilkan di sini; DP ditahan sampai QRIS lunas). Pembayaran bagi tidak digabung.
 */
const ReservasiBayarPanel = ({ total, state, onChange, daftar, nonCashMethods, disabled, sx, qrisAktif = false, qris = null, orderId = '' }) => {
  const h = hitungReservasiBayar(total, state, daftar, nonCashMethods);
  const ubah = (k) => (e) => onChange({ ...state, [k]: e.target.value });
  return (
    <Box sx={sx} data-testid="panel-reservasi-bayar">
      <TextField
        select
        fullWidth
        size="small"
        label="Reservasi (DP sudah diterima)"
        value={state.uuid}
        onChange={ubah('uuid')}
        disabled={disabled || !!qris}
        sx={{ mb: 1.5 }}
        SelectProps={{ SelectDisplayProps: { 'data-testid': 'pilih-reservasi' } }}
      >
        {daftar.map((r) => (
          <MenuItem key={r.uuid} value={r.uuid}>
            {r.jam} · {r.nama} · {r.jumlahOrang} orang{r.meja ? ` · ${namaMejaReservasi(r)}` : ''} — DP {rp(r.dp.nominal)} ({r.kode})
          </MenuItem>
        ))}
      </TextField>

      {h.r && (
        <Box sx={{ p: 1.25, bgcolor: '#f0f2f5', borderRadius: 1, mb: 1.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2">Total</Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{rp(total)}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 600 }}>DP reservasi {h.r.kode}</Typography>
            <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 600 }}>- {rp(h.dpPakai)}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>Sisa dibayar</Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }} data-testid="sisa-bayar">{rp(h.sisa)}</Typography>
          </Box>
          {h.sisaDpKembali > 0 && (
            <Alert severity="warning" sx={{ mt: 1, py: 0 }}>DP lebih besar dari tagihan: kembalikan {rp(h.sisaDpKembali)} ke pelanggan.</Alert>
          )}
        </Box>
      )}

      {h.r && h.lunasDenganDp && <Alert severity="success">Tagihan lunas dengan DP. Tekan Bayar untuk menyelesaikan.</Alert>}

      {h.r && !h.lunasDenganDp && (
        <>
          <RadioGroup row value={state.metode} onChange={ubah('metode')} sx={{ mb: 1 }}>
            <FormControlLabel value="cash" control={<Radio size="small" />} label="Sisa tunai" disabled={disabled} />
            <FormControlLabel value="noncash" control={<Radio size="small" />} label="Sisa non-tunai" disabled={disabled || nonCashMethods.length === 0} />
            {qrisAktif && <FormControlLabel value="qris" control={<Radio size="small" />} label="Sisa QRIS" disabled={disabled} data-testid="sisa-qris" />}
          </RadioGroup>
          {state.metode === 'cash' && (
            <>
              <TextField
                fullWidth
                label="Uang Customer"
                type="number"
                placeholder="Masukkan jumlah uang"
                value={state.cash}
                onChange={ubah('cash')}
                disabled={disabled}
                inputProps={{ step: '1000', min: '0', 'data-testid': 'reservasi-cash' }}
              />
              {state.cash !== '' && (
                <Typography variant="body2" sx={{ mt: 0.75, fontWeight: 700, color: h.sah ? '#16a34a' : '#dc2626' }}>
                  {h.sah ? `Kembalian ${rp(h.kembalian)}` : h.galat}
                </Typography>
              )}
            </>
          )}
          {state.metode === 'qris' && (
            <Box sx={{ textAlign: 'center', py: 1 }}>
              <Typography variant="body2" sx={{ color: '#6b778c', mb: 1 }}>
                {qris ? `Pelanggan memindai QRIS sebesar ${rp(h.sisa)}` : `Klik Bayar untuk membuat QRIS sebesar ${rp(h.sisa)} (DP ${rp(h.dpPakai)} ditahan sampai lunas)`}
              </Typography>
              {qris && <QrisKasir qris={qris} orderId={orderId} />}
            </Box>
          )}
          {state.metode === 'noncash' && (
            <TextField select fullWidth size="small" label="Pilih Metode" value={state.nonCashUuid} onChange={ubah('nonCashUuid')} disabled={disabled}>
              {nonCashMethods.map((m) => <MenuItem key={m.uuid} value={m.uuid}>{m.name}</MenuItem>)}
            </TextField>
          )}
        </>
      )}
      <Typography variant="caption" sx={{ color: '#6b778c', display: 'block', mt: 1 }}>
        DP reservasi tidak bisa digabung dengan Bagi atau DP piutang.
      </Typography>
    </Box>
  );
};

export default ReservasiBayarPanel;
